import { defineComponent as x, useCssModule as T, inject as y, computed as r, onMounted as k, nextTick as g, toRefs as c, createElementBlock as C, openBlock as u, withKeys as P, normalizeClass as $, unref as a, createBlock as B, resolveDynamicComponent as E, mergeProps as N, withCtx as b, createElementVNode as A, createVNode as I, renderSlot as M } from "vue";
import j from "@leaflink/snitch";
import D from "./Badge.js";
import { T as L } from "./Tabs.vue_vue_type_script_setup_true_lang-CmnBP4i1.js";
import { _ as V } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const K = ["id", "aria-selected", "aria-controls", "aria-disabled"], O = { class: "tw-mt-0.5" }, S = /* @__PURE__ */ x({
  __name: "Tab",
  props: {
    value: {},
    to: {},
    href: {},
    badge: {},
    disabled: { type: Boolean },
    anchorProps: {},
    routerLinkProps: {}
  },
  setup(p) {
    const e = p, v = T(), l = y(L.key);
    if (!l)
      throw Error("The Tab component must be a child of the Tabs component.");
    const { setActiveTab: w, activeTab: f, variant: o } = l, t = r(() => e.value === f.value), m = r(() => e.to ? "router-link" : e.href ? "a" : "button");
    function d(i) {
      e.disabled || w(i);
    }
    const n = r(() => `tabpanel-${e.value}`);
    k(async () => {
      await g(), process.env.NODE_ENV !== "test" && t.value && !document.getElementById(n.value) && j.warn(
        `The <Tab> with value "${e.value}" is active, but its corresponding tab panel cannot be found. Please ensure that the corresponding tab panel has an "id" attribute with value "${n.value}" and a "role" attribute with value "tabpanel".`
      );
    });
    const h = r(() => e.to && e.routerLinkProps ? c(e.routerLinkProps) : e.href && e.anchorProps ? c(e.anchorProps) : {});
    return (i, s) => (u(), C("li", {
      id: `tab-${e.value}`,
      role: "tab",
      "aria-selected": t.value,
      "aria-controls": n.value,
      "aria-disabled": e.disabled,
      class: $(["stash-tab", [
        {
          "stash-tab--active is-active": t.value,
          "stash-tab--disabled": e.disabled,
          "stash-tab--variant-line": a(o) === "line",
          "stash-tab--variant-enclosed": a(o) === "enclosed"
        }
      ]]),
      onClick: s[0] || (s[0] = (_) => d(e.value)),
      onKeypress: s[1] || (s[1] = P((_) => d(e.value), ["enter"]))
    }, [
      (u(), B(E(m.value), N(h.value, {
        to: e.to,
        href: e.href,
        class: ["tw-relative tw-flex tw-cursor-pointer tw-items-center tw-justify-center tw-whitespace-nowrap tw-border-solid tw-py-1.5 tw-text-sm tw-font-medium hover:tw-no-underline", [
          {
            "tw-border-b-2": a(o) === "line",
            "tw-border-b tw-border-t-4 tw-px-6": a(o) === "enclosed",
            "tw-rounded-t tw-border-b-ice-200 tw-bg-white": t.value && a(o) === "enclosed",
            [a(v)["custom-shadow"]]: t.value && a(o) === "enclosed",
            "focus:tw-no-underline": e.href,
            "tw-pointer-events-none tw-text-ice-500": e.disabled,
            "tw-text-ice-700": !e.disabled && !t.value
          },
          [
            t.value ? "tw-border-blue-500 tw-text-blue-500" : "tw-border-transparent hover:tw-text-blue-500 focus:tw-text-blue-500"
          ]
        ]],
        tabindex: e.disabled ? -1 : 0
      }), {
        default: b(() => [
          A("div", O, [
            I(D, {
              content: e.badge,
              position: "inline",
              color: "red",
              "is-disabled": e.disabled
            }, {
              default: b(() => [
                M(i.$slots, "default", {
                  isActive: t.value,
                  isDisabled: e.disabled,
                  variant: a(o)
                })
              ]),
              _: 3
            }, 8, ["content", "is-disabled"])
          ])
        ]),
        _: 3
      }, 16, ["to", "href", "class", "tabindex"]))
    ], 42, K));
  }
}), z = {
  "custom-shadow": "_custom-shadow_16n7s_3"
}, J = {
  $style: z
}, Q = /* @__PURE__ */ V(S, [["__cssModules", J]]);
export {
  Q as default
};
//# sourceMappingURL=Tab.js.map
